import AppActions from '../app/actions';
import AuthActions from '../auth/actions';
import ImageAssets from '../imageAssets/actions';
import MapConfigActions from '../map/actions';
import ModalActions from '../modals/actions';
import Notes from '../notes/actions';
import PropertiesActions from '../properties/actions';
import User from '../user/actions';

export const Actions = {
  ...AuthActions,
  ...AppActions,
  ...PropertiesActions,
  ...ModalActions,
  ...MapConfigActions,
  ...ImageAssets,
  ...User,
  ...Notes,
};
